import { render, staticRenderFns } from "./params_edit.vue?vue&type=template&id=a6d1b900&lang=pug&"
import script from "./params_edit.vue?vue&type=script&lang=coffee&"
export * from "./params_edit.vue?vue&type=script&lang=coffee&"
import style0 from "./params_edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports